"use client";

import { useState } from "react";
import SelectionCard, { ChoiceRow } from "./SelectionCard";

type Tier = "fast" | "deep";

interface TierOption {
  id: Tier;
  label: string;
  prefix: string;
}

const TIERS: TierOption[] = [
  { id: "fast", label: "Fast", prefix: "~30–60s" },
  { id: "deep", label: "Deep", prefix: "~15–40m" },
];

interface TierSelectorProps {
  onSelect: (tier: Tier) => void;
}

export default function TierSelector({ onSelect }: TierSelectorProps) {
  const [selected, setSelected] = useState<Tier | null>(null);

  return (
    <SelectionCard
      label="EXECUTION SPEED"
      title="How fast do you need this?"
      onConfirm={() => { if (selected) onSelect(selected); }}
      confirmDisabled={!selected}
    >
      {TIERS.map((tier) => (
        <ChoiceRow
          key={tier.id}
          label={tier.label}
          prefix={tier.prefix}
          selected={selected === tier.id}
          onClick={() => setSelected(tier.id)}
        />
      ))}
    </SelectionCard>
  );
}
